<div class="container">
  @if (!loading) {
    <!-- Connection Details Section -->
    <div class="details-section">
      <div class="top-bar">
        <h2>Connection Details</h2>
        <a href="javascript:void(0)" (click)="onManageConnectionUsers()">
          <svg
            width="16"
            height="16"
            viewBox="0 0 640 640"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M320 80C377.4 80 424 126.6 424 184C424 241.4 377.4 288 320 288C262.6 288 216 241.4 216 184C216 126.6 262.6 80 320 80zM96 152C135.8 152 168 184.2 168 224C168 263.8 135.8 296 96 296C56.2 296 24 263.8 24 224C24 184.2 56.2 152 96 152zM0 480C0 409.3 57.3 352 128 352C140.8 352 153.2 353.9 164.9 357.4C132 394.2 112 442.8 112 496L112 512C112 523.4 114.4 534.2 118.7 544L32 544C14.3 544 0 529.7 0 512L0 480zM521.3 544C525.6 534.2 528 523.4 528 512L528 496C528 442.8 508 394.2 475.1 357.4C486.8 353.9 499.2 352 512 352C582.7 352 640 409.3 640 480L640 512C640 529.7 625.7 544 608 544L521.3 544zM472 224C472 184.2 504.2 152 544 152C583.8 152 616 184.2 616 224C616 263.8 583.8 296 544 296C504.2 296 472 263.8 472 224zM160 496C160 407.6 231.6 336 320 336C408.4 336 480 407.6 480 496L480 512C480 529.7 465.7 544 448 544L192 544C174.3 544 160 529.7 160 512L160 496z"
            />
          </svg>
          Manage Users
        </a>
      </div>

      @if (connection.connection_type === 1 && !connection.available_in_auth0) {
        <div class="signup-banner">
          <div class="banner-icon">ℹ️</div>
          <div class="banner-text">
            This connection’s signup request has been approved, but they have
            not yet joined the portal. Therefore, certain fields such as Client
            ID and Client Secret are currently empty and will be populated once
            they join.
          </div>
        </div>
      }

      <form #connectionForm="ngForm">
        <div class="form-field">
          <label for="logo-upload">Logo</label>

          @if (!imageUrl) {
            <label
              class="upload-box"
              [class.drag-over]="isDragOver"
              (dragover)="onDragOver($event)"
              (dragleave)="onDragLeave($event)"
              (drop)="onDrop($event)"
            >
              <input
                id="logo-upload"
                type="file"
                accept=".jpg, .jpeg, .png, .heic, .heif"
                (change)="onLogoSelected($event)"
                hidden
              />

              <div class="upload-content">
                <span class="upload-btn">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 16V4M12 4L7 9M12 4L17 9"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20 16.5V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V16.5"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>

                  Upload Logo
                </span>

                <span class="upload-text">
                  {{ isDragOver ? "Drop logo here" : "Or drop the logo" }}
                </span>
              </div>
            </label>
          } @else {
            <div class="logo-container">
              <div class="logo-circle">
                <img [src]="imageUrl" alt="Logo" class="logo-preview" />

                <button
                  type="button"
                  class="avatar-edit-button"
                  (click)="toggleLogoMenu(); $event.stopPropagation()"
                  aria-label="Edit logo"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M3 17.25V21H6.75L17.81 9.94L14.06 6.19L3 17.25ZM20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C17.98 2.9 17.35 2.9 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>

                @if (showLogoMenu) {
                  <div
                    class="profile-dropdown"
                    (click)="$event.stopPropagation()"
                    (keydown.enter)="$event.stopPropagation()"
                    tabindex="0"
                    (appClickOutside)="showLogoMenu = false"
                  >
                    <ul class="logo-options">
                      <li class="logo-option">
                        <label class="dropdown-action" for="change-logo">
                          Change logo

                          <span class="icon">
                            <svg
                              width="15"
                              height="15"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 640 640"
                            >
                              <path
                                d="M160 144C151.2 144 144 151.2 144 160L144 480C144 488.8 151.2 496 160 496L480 496C488.8 496 496 488.8 496 480L496 160C496 151.2 488.8 144 480 144L160 144zM96 160C96 124.7 124.7 96 160 96L480 96C515.3 96 544 124.7 544 160L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 160zM224 192C241.7 192 256 206.3 256 224C256 241.7 241.7 256 224 256C206.3 256 192 241.7 192 224C192 206.3 206.3 192 224 192zM360 264C368.5 264 376.4 268.5 380.7 275.8L460.7 411.8C465.1 419.2 465.1 428.4 460.8 435.9C456.5 443.4 448.6 448 440 448L200 448C191.1 448 182.8 443 178.7 435.1C174.6 427.2 175.2 417.6 180.3 410.3L236.3 330.3C240.8 323.9 248.1 320.1 256 320.1C263.9 320.1 271.2 323.9 275.7 330.3L292.9 354.9L339.4 275.9C343.7 268.6 351.6 264.1 360.1 264.1z"
                              ></path>
                            </svg>
                          </span>
                        </label>

                        <input
                          id="change-logo"
                          type="file"
                          accept=".jpg, .jpeg, .png, .heic, .heif"
                          hidden
                          (change)="onLogoSelected($event)"
                        />
                      </li>

                      <li
                        class="logo-option danger"
                        (click)="removeLogo()"
                        (keydown.enter)="removeLogo()"
                        tabindex="0"
                      >
                        Remove

                        <span class="icon">
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M3 6H21"
                              stroke="currentColor"
                              stroke-width="2"
                            />
                            <path
                              d="M19 6V20C19 21 18 22 17 22H7C6 22 5 21 5 20V6"
                              stroke="currentColor"
                              stroke-width="2"
                            />
                            <path
                              d="M8 6V4C8 3 9 2 10 2H14C15 2 16 3 16 4V6"
                              stroke="currentColor"
                              stroke-width="2"
                            />
                          </svg>
                        </span>
                      </li>
                    </ul>
                  </div>
                }
              </div>
            </div>
          }
        </div>
        <div class="form-field readonly">
          <label for="connectionName">Connection Name</label>
          <input id="connectionName" [value]="connection.name" readonly />
        </div>
        <div class="form-field required">
          <label for="displayName">Display Name</label>
          <input
            id="displayName"
            [(ngModel)]="connection.display_name"
            name="display_name"
            placeholder="Enter display name"
          />
        </div>
        @if (connection.connection_type === 1) {
          <div class="form-field readonly">
            <label for="strategy">Strategy</label>
            <input
              id="strategy"
              [value]="strategies[connection.strategy] || ''"
              readonly
            />
          </div>
          <div
            class="form-field required"
            [class.readonly]="!connection.available_in_auth0"
          >
            <label for="domain">Domain</label>
            <input
              id="domain"
              [(ngModel)]="connection.domain"
              name="domain"
              [placeholder]="
                connection.available_in_auth0 ? 'your-domain.com' : ''
              "
              [readonly]="!connection.available_in_auth0"
            />
          </div>

          <div
            class="form-field required"
            [class.readonly]="!connection.available_in_auth0"
          >
            <label for="client_id">Client ID</label>
            <input
              id="client_id"
              [(ngModel)]="connection.client_id"
              name="client_id"
              [placeholder]="
                connection.available_in_auth0 ? 'Enter client ID' : ''
              "
              [readonly]="!connection.available_in_auth0"
            />
          </div>

          <div
            class="form-field password required"
            [class.readonly]="!connection.available_in_auth0"
          >
            <label for="clientSecret">Client Secret</label>
            <input
              id="clientSecret"
              [(ngModel)]="connection.client_secret"
              name="client_secret"
              type="password"
              [placeholder]="
                connection.available_in_auth0 ? 'Enter client secret' : ''
              "
              [readonly]="!connection.available_in_auth0"
            />
          </div>
        }

        <button class="submit-button" (click)="showUpdateConfirmPopup = true">
          Save Changes
        </button>
      </form>

      <div class="toggle-field">
        <div class="hide-toggle-container">
          <span class="toggle-title">Hide from Public</span>
          <label class="toggle">
            <input
              type="checkbox"
              id="hideToggle"
              [(ngModel)]="connection.hide"
              (change)="onHideToggleChange()"
              name="hide"
            />
            <span class="slider"></span>
          </label>
        </div>
      </div>
    </div>

    <!-- CRM Configuration Section -->
    @if (showCRMIntegration) {
      <div class="crm-section" [class.crm-disabled]="!isCrmEnabled">
        @if (crmLoading) {
          <div class="configuring-loader">
            <div class="configuring-text">
              Loading CRM roles
              <div class="dot-loader">
                <span>.</span>
                <span>.</span>
                <span>.</span>
              </div>
            </div>
          </div>
        } @else {
          <div class="top-bar">
            <h2>CRM Integration</h2>
            <div class="crm-toggle-container">
              <label class="crm-toggle">
                <input
                  type="checkbox"
                  [(ngModel)]="isCrmEnabled"
                  (change)="onCrmToggleChange()"
                />
                <span class="crm-slider"></span>
              </label>
              <span class="toggle-label">{{
                isCrmEnabled ? "Enabled" : "Disabled"
              }}</span>
            </div>
          </div>

          @if (isCrmEnabled) {
            <div class="crm-role-selection">
              <div class="form-field" [class.readonly]="isCrmRoleReadonly">
                <label for="crmRole"
                  >CRM Role
                  @if (!isCrmRoleReadonly) {
                    <span class="required-star">*</span>
                  }
                  {{ isCrmRoleReadonly ? "(Cannot be changed)" : "" }}</label
                >
                @if (isCrmRoleReadonly) {
                  <input
                    id="crmRole"
                    [value]="getCrmRoleDisplayName()"
                    readonly
                    class="readonly-input"
                  />
                } @else {
                  <select
                    id="crmRole"
                    [(ngModel)]="selectedCrmRoleId"
                    (change)="onCrmRoleSelectionChange()"
                    class="crm-role-dropdown"
                  >
                    @for (role of allCrmRoles; track role.role_id) {
                      <option [value]="role.role_id">
                        {{ role.role_name }}
                      </option>
                    }
                  </select>

                  <!-- Message for first-time CRM enablement -->
                  @if (!selectedCrmRoleId && !originalSelectedCrmRoleId) {
                    <div class="crm-first-time-message">
                      <div class="message-icon">ℹ️</div>
                      <div class="message-text">
                        <strong>Please select a role to enable CRM.</strong>
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
          }
        }
      </div>
    }

    @if (connection.connection_type === 2) {
      <div class="invite-user-container">
        <div class="invite-user-section">
          <div class="invite-header">
            <h3>User Invitations</h3>
            <button
              type="button"
              class="invite-button"
              (click)="showInviteUserPopup = true"
              [disabled]="isInviteUserButtonDisabled()"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path
                  d="M15,14C12.33,14 7,15.33 7,18V20H23V18C23,15.33 17.67,14 15,14M6,10V7H4V10H1V12H4V15H6V12H9V10M15,12A4,4 0 0,0 19,8A4,4 0 0,0 15,4A4,4 0 0,0 11,8A4,4 0 0,0 15,12Z"
                />
              </svg>
              Invite User
            </button>
          </div>

          <div class="invite-description">
            <p>
              Send email invitations to users who can join this connection.
              Invited users will receive an email to complete their
              registration.
            </p>
          </div>

          <!-- Invited Users List -->
          <div class="invitations-list">
            @if (invitations.length === 0) {
              <div class="no-invitations">
                <div class="no-data-icon">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="#94a3b8"
                  >
                    <path
                      d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 1H5C3.89 1 3 1.89 3 3V21C3 22.1 3.89 23 5 23H19C20.1 23 21 22.1 21 21V9M19 9H14V4H5V21H19V9Z"
                    />
                  </svg>
                </div>
                <p>No users have been invited yet</p>
                <p class="sub-text">
                  Click "Invite User" button above to send your first invitation
                </p>
              </div>
            } @else {
              <div class="invitation-items-grid">
                @for (invitation of invitations; track $index) {
                  <div class="invitation-row">
                    <div class="invitation-avatar">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path
                          d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"
                        />
                      </svg>
                    </div>
                    <div class="invitation-details">
                      <div class="invitation-email">{{ invitation.email }}</div>
                      <div class="invitation-dates">
                        <span class="invited-date">
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path
                              d="M19,3H18V1H16V3H8V1H6V3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V8H19V19Z"
                            />
                          </svg>
                          Invited:
                          {{
                            invitation.invited_on_utc
                              | date: "MMM d, yyyy hh:mm a"
                          }}
                        </span>
                        @if (!invitation.accepted_on_utc) {
                          <span class="invitation-url">
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                            >
                              <path
                                d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
                              />
                            </svg>
                            Invitation URL:
                            <span
                              class="url-text"
                              [title]="getInviteLink(invitation.url_id)"
                            >
                              {{ getInviteLink(invitation.url_id) }}
                            </span>
                            <button
                              type="button"
                              class="copy-link-btn"
                              [class.copied]="
                                copiedInvitationId === invitation.url_id
                              "
                              (click)="copyToClipboard(invitation.url_id)"
                              [title]="
                                copiedInvitationId === invitation.url_id
                                  ? 'Copied!'
                                  : 'Copy link'
                              "
                            >
                              @if (copiedInvitationId === invitation.url_id) {
                                <svg
                                  class="check-icon"
                                  width="11"
                                  height="11"
                                  viewBox="0 0 24 24"
                                  fill="currentColor"
                                >
                                  <path
                                    d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
                                  />
                                </svg>
                              } @else {
                                <svg
                                  width="11"
                                  height="11"
                                  viewBox="0 0 24 24"
                                  fill="currentColor"
                                >
                                  <path
                                    d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z"
                                  />
                                </svg>
                              }
                            </button>
                          </span>
                        }
                        @if (invitation.accepted_on_utc) {
                          <span class="accepted-date">
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                            >
                              <path
                                d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
                              />
                            </svg>
                            Accepted:
                            {{
                              invitation.accepted_on_utc
                                | date: "MMM d, yyyy hh:mm a"
                            }}
                          </span>
                        }
                      </div>
                    </div>
                    <div class="invitation-status">
                      <span
                        class="status-badge"
                        [class]="
                          invitation.accepted_on_utc
                            ? 'status-accepted'
                            : 'status-pending'
                        "
                      >
                        {{
                          invitation.accepted_on_utc ? "Accepted" : "Pending"
                        }}
                      </span>
                    </div>
                    <div class="invitation-actions">
                      @if (!invitation.accepted_on_utc) {
                        <button
                          type="button"
                          class="delete-btn"
                          (click)="onDeleteInvitation(invitation)"
                          title="Cancel Invitation"
                        >
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path
                              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                            />
                          </svg>
                        </button>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }

    <!-- Subscription Details Section -->
    <section class="arcgis-section" [class.collapsed]="!isSubscriptionExpanded">
      <div
        class="section-header"
        role="button"
        tabindex="0"
        (click)="toggleSubscription()"
        (keydown.enter)="toggleSubscription()"
        (keydown.space)="toggleSubscription()"
      >
        <div class="header-title">
          @if (isSubscriptionExpanded) {
            <div class="chevron">
              <svg
                width="20"
                height="20"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  fill="currentColor"
                  d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
                />
              </svg>
            </div>
          } @else {
            <div class="chevron">
              <svg
                width="20"
                height="20"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
              >
                <path
                  fill="currentColor"
                  d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
                />
              </svg>
            </div>
          }
          <h2>Subscription Details</h2>
        </div>
        <span class="group-count">
          @if (subscriptionLoading) {
            Loading...
          } @else if (subscriptionDetails?.display_name) {
            {{ subscriptionDetails?.display_name }}
          } @else if (subscriptionDetails?.plan_name) {
            {{ subscriptionDetails?.plan_name }}
          } @else {
            Free Plan
          }
        </span>
      </div>
      @if (isSubscriptionExpanded) {
        <div class="subscription-details-content">
          @if (subscriptionLoading) {
            <div class="configuring-loader">
              <div class="configuring-text">
                Loading subscription details
                <div class="dot-loader">
                  <span>.</span><span>.</span><span>.</span>
                </div>
              </div>
            </div>
          } @else if (
            subscriptionDetails && subscriptionDetails.plan_name !== "free_plan"
          ) {
            <div class="sub-info-grid">
              <div class="sub-info-row">
                <span class="sub-label">Plan</span>
                <span class="sub-value">
                  <a
                    class="plan-link"
                    href="javascript:void(0)"
                    (click)="navigateToPlan(subscriptionDetails.plan_name)"
                    >{{
                      subscriptionDetails.display_name ||
                        subscriptionDetails.plan_name
                    }}</a
                  >
                </span>
              </div>
              <div class="sub-info-row">
                <span class="sub-label">Status</span>
                <span class="sub-value">
                  <span
                    class="status-badge"
                    [ngClass]="getStatusClass(subscriptionDetails.status)"
                  >
                    {{ subscriptionDetails.status }}
                  </span>
                </span>
              </div>
              @if (
                subscriptionDetails.amount !== null &&
                subscriptionDetails.amount !== undefined
              ) {
                <div class="sub-info-row">
                  <span class="sub-label">Amount</span>
                  <span class="sub-value"
                    >${{ subscriptionDetails.amount }} /
                    {{ subscriptionDetails.billing_interval }}</span
                  >
                </div>
              }
              @if (subscriptionDetails.billing_interval) {
                <div class="sub-info-row">
                  <span class="sub-label">Billing Interval</span>
                  <span class="sub-value">{{
                    subscriptionDetails.billing_interval === "month"
                      ? "Monthly"
                      : "Yearly"
                  }}</span>
                </div>
              }
              @if (
                subscriptionDetails.current_period_start &&
                subscriptionDetails.current_period_end
              ) {
                <div class="sub-info-row">
                  <span class="sub-label">Current Period</span>
                  <span class="sub-value"
                    >{{
                      subscriptionDetails.current_period_start
                        | date: "MMM d, yyyy"
                    }}
                    —
                    {{
                      subscriptionDetails.current_period_end
                        | date: "MMM d, yyyy"
                    }}</span
                  >
                </div>
              }
              @if (
                subscriptionDetails.is_trialing && subscriptionDetails.trial_end
              ) {
                <div class="sub-info-row">
                  <span class="sub-label">Trial Ends</span>
                  <span class="sub-value">{{
                    subscriptionDetails.trial_end | date: "MMM d, yyyy"
                  }}</span>
                </div>
              }
              <div class="sub-info-row">
                <span class="sub-label">Subscription Admin</span>
                <span class="sub-value">
                  @if (subscriptionAdminName && subscriptionAdminEmail) {
                    <span class="sub-admin-name">{{
                      subscriptionAdminName
                    }}</span>
                    <span class="sub-admin-email"
                      >({{ subscriptionAdminEmail }})</span
                    >
                  } @else if (subscriptionAdminName) {
                    <span class="sub-admin-name">{{
                      subscriptionAdminName
                    }}</span>
                  } @else if (subscriptionAdminEmail) {
                    <span class="sub-admin-email-only">{{
                      subscriptionAdminEmail
                    }}</span>
                  } @else {
                    <span class="sub-empty">—</span>
                  }
                </span>
              </div>
            </div>
          } @else {
            <div class="no-subscription">
              <span>This connection is on the Free Plan.</span>
            </div>
          }
        </div>
      }
    </section>

    <!-- ArcGIS Groups Section -->
    <section class="arcgis-section" [class.collapsed]="!isArcGisGroupsExpanded">
      <div
        class="section-header"
        role="button"
        tabindex="0"
        (click)="toggleArcGisGroups()"
        (keydown.enter)="toggleArcGisGroups()"
        (keydown.space)="toggleArcGisGroups()"
      >
        <div class="header-title">
          @if (isArcGisGroupsExpanded) {
            <div class="chevron">
              <svg
                width="20"
                height="20"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  fill="currentColor"
                  d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
                />
              </svg>
            </div>
          } @else {
            <div class="chevron">
              <svg
                width="20"
                height="20"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
              >
                <path
                  fill="currentColor"
                  d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
                />
              </svg>
            </div>
          }
          <h2>ArcGIS Dashboards</h2>
        </div>
        <span class="group-count"
          >{{ connectionArcGisGroupEnabled }}/{{
            arcGisDashboardList.length
          }}
          dashboards</span
        >
      </div>
      @if (isArcGisGroupsExpanded) {
        <div class="groups-list">
          @for (group of allArcGisDashboards; track group) {
            <div class="group-item">
              <span class="group-name">{{ group.title }}</span>
              <label class="toggle">
                <input
                  type="checkbox"
                  [(ngModel)]="connectionArcGisGroupMap[group.type]"
                  (change)="onConnectionArcGisGroupChange(group.type, $event)"
                />
                <span class="slider"></span>
              </label>
            </div>
          }
        </div>
      }
    </section>

    <!-- EULA Section -->
    <section class="arcgis-section" [class.collapsed]="!isEulaExpanded">
      <div
        class="section-header"
        role="button"
        tabindex="0"
        (click)="toggleEula()"
        (keydown.enter)="toggleEula()"
        (keydown.space)="toggleEula()"
      >
        <div class="header-title">
          @if (isEulaExpanded) {
            <div class="chevron">
              <svg
                width="20"
                height="20"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  fill="currentColor"
                  d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
                />
              </svg>
            </div>
          } @else {
            <div class="chevron">
              <svg
                width="20"
                height="20"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
              >
                <path
                  fill="currentColor"
                  d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
                />
              </svg>
            </div>
          }
          <h2>EULA</h2>
        </div>
        <span class="group-count">
          {{ getSelectedEulaTitle() }}
        </span>
      </div>
      @if (isEulaExpanded) {
        <div class="groups-list">
          @if (eulaLoading) {
            <div class="configuring-loader">
              <div class="configuring-text">
                Loading EULA settings
                <div class="dot-loader">
                  <span>.</span>
                  <span>.</span>
                  <span>.</span>
                </div>
              </div>
            </div>
          } @else {
            <div class="form-field">
              <label for="eulaSelect">Select EULA Type</label>
              <select
                id="eulaSelect"
                [ngModel]="dropdownEulaType"
                (ngModelChange)="onConnectionEulaChange($event)"
                name="eulaType"
                [disabled]="eulaLoading"
              >
                @for (eula of allEulaItems; track eula) {
                  <option [value]="eula.type">{{ eula.title }}</option>
                }
              </select>
            </div>
          }
        </div>
      }
    </section>

    <!-- PDM (File Operations) Section -->
    <section class="arcgis-section" [class.collapsed]="!isPdmExpanded">
      <div
        class="section-header"
        role="button"
        tabindex="0"
        (click)="isPdmExpanded = !isPdmExpanded"
        (keydown.enter)="isPdmExpanded = !isPdmExpanded"
        (keydown.space)="isPdmExpanded = !isPdmExpanded"
      >
        <div class="header-title">
          @if (isPdmExpanded) {
            <div class="chevron">
              <svg
                width="20"
                height="20"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  fill="currentColor"
                  d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
                />
              </svg>
            </div>
          } @else {
            <div class="chevron">
              <svg
                width="20"
                height="20"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
              >
                <path
                  fill="currentColor"
                  d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
                />
              </svg>
            </div>
          }
          <h2>File Operation</h2>
        </div>
        <span class="group-count">
          {{ isPdmEnabled ? "Enabled" : "Disabled" }}
        </span>
      </div>
      @if (isPdmExpanded) {
        <div class="groups-list">
          @if (pdmLoading) {
            <div class="configuring-loader">
              <div class="configuring-text">
                Loading PDM settings
                <div class="dot-loader">
                  <span>.</span>
                  <span>.</span>
                  <span>.</span>
                </div>
              </div>
            </div>
          } @else {
            <div class="group-item">
              <span class="group-name">PDM</span>
              <label class="toggle">
                <input
                  type="checkbox"
                  id="pdmToggle"
                  [(ngModel)]="isPdmEnabled"
                  (change)="onPdmToggleChange()"
                />
                <span class="slider"></span>
              </label>
            </div>
          }
        </div>
      }
    </section>

    @if (connection.connection_type === 1) {
      <section class="arcgis-section" [class.collapsed]="!isClientsExpanded">
        <div
          class="section-header"
          role="button"
          tabindex="0"
          (click)="toggleClients()"
          (keydown.enter)="toggleClients()"
          (keydown.space)="toggleClients()"
        >
          <div class="header-title">
            @if (isClientsExpanded) {
              <div class="chevron">
                <svg
                  width="20"
                  height="20"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="currentColor"
                    d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
                  />
                </svg>
              </div>
            } @else {
              <div class="chevron">
                <svg
                  width="20"
                  height="20"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                >
                  <path
                    fill="currentColor"
                    d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
                  />
                </svg>
              </div>
            }
            <h2>Clients</h2>
          </div>
          @if (connection.enabled_clients) {
            <span class="group-count"
              >{{ connection.enabled_clients.length }}/{{
                allClients.length
              }}
              clients</span
            >
          }
        </div>
        @if (isClientsExpanded) {
          <div class="groups-list">
            @for (client of allClients; track client) {
              <div class="group-item">
                <span class="group-name">{{ client.name }}</span>
                <label class="toggle">
                  <input
                    type="checkbox"
                    [(ngModel)]="connectionClientMap[client.client_id]"
                    (change)="
                      onConnectionClientChange(
                        client.client_id,
                        connectionClientMap[client.client_id]
                      )
                    "
                  />
                  <span class="slider"></span>
                </label>
              </div>
            }
          </div>
        }
      </section>
    }

    <!-- Delete Connection Section -->
    <div class="delete-section">
      <div class="danger-header">
        <span class="danger-title">⚠️ Danger Zone</span>
        <span class="danger-subtitle">This action cannot be undone</span>
      </div>
      <button
        class="delete-button"
        [disabled]="!isDeleteConnectionAllowed()"
        (click)="showDeleteConfirmPopup = true"
      >
        Delete Connection
      </button>
    </div>
  } @else {
    <!-- Loading Skeleton -->
    <div class="details-section loading-section">
      <div class="skeleton-header"></div>
      <div class="skeleton-line medium"></div>
      <div class="skeleton-line long"></div>
      <div class="skeleton-line short"></div>
      <div class="skeleton-line medium"></div>
      <div style="margin-top: 24px; display: flex; justify-content: flex-end">
        <div class="skeleton-button"></div>
      </div>
    </div>

    <section class="groups-section loading-section">
      <div class="skeleton-content">
        <div
          class="skeleton-header"
          style="width: 150px; margin-bottom: 12px"
        ></div>
        <div class="skeleton-line long"></div>
        <div class="skeleton-line medium"></div>
        <div class="skeleton-line short"></div>
      </div>
    </section>

    <section class="groups-section loading-section">
      <div class="skeleton-content">
        <div
          class="skeleton-header"
          style="width: 180px; margin-bottom: 12px"
        ></div>
        <div class="skeleton-line short"></div>
        <div class="skeleton-line long"></div>
        <div class="skeleton-line medium"></div>
      </div>
    </section>

    <section class="groups-section loading-section">
      <div class="skeleton-content">
        <div
          class="skeleton-header"
          style="width: 120px; margin-bottom: 12px"
        ></div>
        <div class="skeleton-line medium"></div>
        <div class="skeleton-line short"></div>
        <div class="skeleton-line long"></div>
      </div>
    </section>
  }
</div>

@if (showDeleteConfirmPopup) {
  <app-popup
    [heading]="'Are you sure you want to delete?'"
    [confirmText]="'Delete'"
    [cancelText]="'Cancel'"
    [popupPosition]="'absolute'"
    (confirmClicked)="deleteConnection()"
    (cancelClicked)="showDeleteConfirmPopup = false"
  >
    <div class="lead-unassign-popup-content">
      {{ connection.name }}
    </div>
  </app-popup>
}

@if (showUpdateConfirmPopup) {
  <app-popup
    [heading]="'Are you sure you want to update this auth0 connection?'"
    [confirmText]="'Update'"
    [cancelText]="'Cancel'"
    [popupPosition]="'absolute'"
    (confirmClicked)="saveConnection()"
    (cancelClicked)="showUpdateConfirmPopup = false"
  >
    <div class="lead-unassign-popup-content">
      {{ connection.name }}
    </div>
  </app-popup>
}

@if (showInviteUserPopup) {
  <app-popup
    [heading]="'Invite User'"
    [confirmText]="isInviting ? 'Sending...' : 'Send Invitation'"
    [cancelText]="'Cancel'"
    [popupPosition]="'absolute'"
    [isConfirmDisabled]="isInviteButtonDisabled()"
    (confirmClicked)="onInviteUser()"
    (cancelClicked)="showInviteUserPopup = false; inviteEmail = ''"
  >
    <div class="invite-user-popup-content">
      <div class="form-field">
        <label for="inviteEmail">Email Address</label>
        <input
          id="inviteEmail"
          type="email"
          [(ngModel)]="inviteEmail"
          placeholder="Enter email address to invite"
          [disabled]="isInviting"
          [class.invalid]="
            inviteEmail.trim() && !isValidEmail(inviteEmail.trim())
          "
          autocomplete="email"
        />
        @if (inviteEmail.trim() && !isValidEmail(inviteEmail.trim())) {
          <span class="error-message">Please enter a valid email address</span>
        }
      </div>
      <p class="invite-description">
        An invitation email will be sent to this user allowing them to join the
        connection.
      </p>
    </div>
  </app-popup>
}

@if (showCancelInvitationPopup) {
  <app-popup
    [heading]="'Are you sure you want to cancel the invitation?'"
    [confirmText]="'Cancel Invitation'"
    [cancelText]="'Keep Invitation'"
    [popupPosition]="'absolute'"
    (confirmClicked)="confirmDeleteInvitation()"
    (cancelClicked)="cancelDeleteInvitation()"
  >
    <div class="lead-unassign-popup-content">
      {{ invitationToDelete?.email }}
    </div>
  </app-popup>
}

@if (showCrmRoleWarningPopup) {
  <app-popup
    [heading]="'Confirm CRM Role'"
    [confirmText]="'Confirm'"
    [cancelText]="'Cancel'"
    [popupPosition]="'absolute'"
    (confirmClicked)="confirmCrmRoleSelection()"
    (cancelClicked)="cancelCrmRoleSelection()"
  >
    <div class="crm-role-warning-popup-content">
      <div class="compact-warning">
        <div class="warning-icon">⚠️</div>
        <div class="warning-text">
          <p class="warning-message">
            Role <strong>{{ getTempSelectedRoleName() }}</strong> cannot be
            changed once selected.
          </p>
          <p class="confirmation-text">Continue?</p>
        </div>
      </div>
    </div>
  </app-popup>
}

@if (showEulaConfirmPopup) {
  <app-popup
    [heading]="'Confirm EULA Change'"
    [confirmText]="'Confirm'"
    [cancelText]="'Cancel'"
    [popupPosition]="'absolute'"
    (confirmClicked)="confirmEulaChange()"
    (cancelClicked)="cancelEulaChange()"
  >
    <div class="eula-confirmation-popup-content">
      <div class="compact-warning">
        <div class="warning-icon">⚠️</div>
        <div class="warning-text">
          <p class="warning-message">
            This will prompt all users under <b>{{ connection.name }}</b> to
            accept the new
            <strong>{{ getTempSelectedEulaTitle() }}</strong> EULA.
          </p>
          <p class="confirmation-text">
            All current accepted EULA info will be reset. Do you want to
            continue?
          </p>
        </div>
      </div>
    </div>
  </app-popup>
}

@if (showPdmConfirmPopup) {
  <app-popup
    [heading]="isPdmEnabled ? 'Enable PDM' : 'Disable PDM'"
    [confirmText]="'Confirm'"
    [cancelText]="'Cancel'"
    [popupPosition]="'absolute'"
    (confirmClicked)="confirmPdmChange()"
    (cancelClicked)="cancelPdmChange()"
  >
    <div class="eula-confirmation-popup-content">
      <div class="compact-warning">
        <div class="warning-icon">⚠️</div>
        <div class="warning-text">
          @if (isPdmEnabled) {
            <p class="warning-message">
              This will enable PDM file operations for
              <b>{{ connection.name }}</b
              >. Uploaded files will be copied to the configured Azure Blob
              destination.
            </p>
          } @else {
            <p class="warning-message">
              This will disable PDM file operations for
              <b>{{ connection.name }}</b
              >. Uploaded files will no longer be copied to the PDM destination.
            </p>
          }
          <p class="confirmation-text">Do you want to continue?</p>
        </div>
      </div>
    </div>
  </app-popup>
}
